export default __webpack_public_path__ + "static/media/home-events-conference-img-10.dff67d57.jpg";